import {createApp} from 'vue'
import Main from './Main.vue'
import router from './router';
import {createI18n} from "vue-i18n";


import {IonicVue} from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
import {App} from '@vue/runtime-core/dist/runtime-core'
import firebase from 'firebase/app';
import app from "./store/db";

import { store, key } from './store/store';




/* Theme variables */
import './theme/variables.css';
const i18n = createI18n({
    legacy: false,
    locale: 'de', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages: {
        en: {},
        de: {
            addreview:'Review',
            taskstate:{
                doing: "Doing",
                todo: "ToDo",
                done: "Done",
            }
        }
    },

});
let vueApp: App<any>|null = null;
app.auth().onAuthStateChanged(async (user) => {
if (!vueApp) {
    vueApp = createApp(Main)
        .use(IonicVue)
        .use(router)
        .use(store,key)
        .use(i18n);
    router.isReady().then(() => {
        vueApp?.mount('#app');
    });
}
if(user){
    console.log("logged in, initialiazing store")
    store.commit('setUser',user)
    store.dispatch('bindTasks');
    store.dispatch('bindReviews');
    store.dispatch('bindTools');
    store.dispatch('bindCategories');

}

});

